interface IconBox {
  icon?: string;
  title: string;
  description?: string;
}

interface IconBoxesProps {
  boxes?: IconBox[];
  columns?: '2' | '3' | '4';
  style?: 'default' | 'bordered' | 'filled';
}

export function IconBoxesBlock({ props }: { props: IconBoxesProps }) {
  const boxes = props.boxes ?? [];
  if (boxes.length === 0) return null;
  const cols = props.columns ?? '3';
  const style = props.style ?? 'default';

  const boxCls = style === 'bordered'
    ? 'border border-zinc-200 rounded-xl p-6'
    : style === 'filled'
      ? 'bg-zinc-50 rounded-xl p-6'
      : 'p-4';

  return (
    <div className={`grid gap-6 ${cols === '2' ? 'grid-cols-1 sm:grid-cols-2' : cols === '4' ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3'}`}>
      {boxes.map((box, i) => (
        <div key={i} className={`${boxCls} text-center`}>
          {box.icon && <div className="text-3xl mb-3">{box.icon}</div>}
          <h3 className="font-semibold text-zinc-900 mb-1">{box.title}</h3>
          {box.description && <p className="text-sm text-zinc-500">{box.description}</p>}
        </div>
      ))}
    </div>
  );
}
